// eslint-disable-next-line no-restricted-imports
import { Drawer, DrawerProps } from 'antd';
import React, { useEffect, useRef } from 'react';
import { useEventTracker } from '@tools/ui/hooks';
import {
  EventExtraDataInput,
  EventType
} from '@tools/ui/types/generated/graphql';

export type TrackedDrawerProps = DrawerProps & {
  analytics: EventExtraDataInput;
};

export const TrackedDrawer: React.FC<
  React.PropsWithChildren<TrackedDrawerProps>
> = ({ open, analytics, ...props }) => {
  const prevOpenRef = useRef<boolean | undefined>(undefined);
  const isMountedRef = useRef(false);
  const { trackEvent } = useEventTracker({
    eventType: EventType.DrawerOpenEvent,
    extraData: analytics
  });

  useEffect(() => {
    const wasOpen = prevOpenRef.current;
    const isOpen = open;
    const isFirstMount = !isMountedRef.current;

    // when transitions from closed to open or
    // when first mounted as already open
    if ((!wasOpen && isOpen) || (isFirstMount && isOpen)) {
      trackEvent();
    }

    prevOpenRef.current = isOpen;
    isMountedRef.current = true;
  }, [open, trackEvent]);

  return <Drawer open={open} {...props} />;
};
